// extracted by mini-css-extract-plugin
module.exports = {"rotation":"HeaderBox_rotation__Ql_6I"};